const reportedUsers = {
  list: {
    main_heading: "admin.reported_users_list_main_heading",
    search_placeholder: "admin.reported_users_list_search_placeholder",
    search_placeholder_feed: "admin.reported_users_list_search_placeholder_feed",
    clear_filter_btn_text: "admin.reported_users_list_clear_filter_btn_text",
    page_size_option: "admin.reported_users_list_page_size_option",
    user_status_option: "admin.reported_users_list_user_status_option",
    content_type_option: "admin.reported_users_list_content_type_option",
    tabs: {
      users: "admin.reported_users_list_tabs_users",
      feed: "admin.reported_users_list_tabs_feed",
    },
    view_image_tooltip: "admin.reported_users_list_view_image_tooltip",
    table: {
      reason_title_col_heading: "admin.reported_users_list_table_reason_title_col_heading",
      reason_description_col_heading: "admin.reported_users_list_table_reason_description_col_heading",
      reporter_name_col_heading: "admin.reported_users_list_table_reporter_name_col_heading",
      reporter_username_col_heading: "admin.reported_users_list_table_reporter_username_col_heading",
      reported_name_col_heading: "admin.reported_users_list_table_reported_name_col_heading",
      reported_username_col_heading: "admin.reported_users_list_table_reported_username_col_heading",
      reported_status_col_heading: "admin.reported_users_list_table_reported_status_col_heading",
      report_status_col_heading: "admin.reported_users_list_table_report_status_col_heading",
      report_date_col_heading: "admin.reported_users_list_table_report_date_col_heading",
      actions_col_heading: "admin.reported_users_list_table_actions_col_heading",
      reported_content_col_heading: "admin.reported_users_list_table_reported_content_col_heading",
      content_owner_col_heading: "admin.reported_users_list_table_content_owner_col_heading",
    },
    content_type: {
      all: "admin.reported_users_list_content_type_all",
      post: "admin.reported_users_list_content_type_post",
      story: "admin.reported_users_list_content_type_story",
    },
    user_status: {
      all: "admin.reported_users_list_user_status_all",
      active: "admin.reported_users_list_user_status_active",
      deactivated: "admin.reported_users_list_user_status_deactivated",
    },
    report_status: {
      pending: "admin.reported_users_list_report_status_pending",
      dismissed: "admin.reported_users_list_report_status_dismissed",
      resolved: "admin.reported_users_list_report_status_resolved",
    },
    delete_popup: {
      heading: "admin.reported_users_list_delete_popup_heading",
      message: "admin.reported_users_list_delete_popup_message",
      message_2: "admin.reported_users_list_delete_popup_message_2",
      yes_btn_text: "admin.reported_users_list_delete_popup_yes_btn_text",
      no_btn_text: "admin.reported_users_list_delete_popup_no_btn_text",
    },
    deactivate_popup: {
      heading: "admin.reported_users_list_deactivate_popup_heading",
      message: "admin.reported_users_list_deactivate_popup_message",
      reason_label: "admin.reported_users_list_deactivate_popup_reason_label",
      reason_placeholder: "admin.reported_users_list_deactivate_popup_reason_placeholder",
      yes_btn_text: "admin.reported_users_list_deactivate_popup_yes_btn_text",
      no_btn_text: "admin.reported_users_list_deactivate_popup_no_btn_text",
    },
    reactivate_popup: {
      heading: "admin.reported_users_list_reactivate_popup_heading",
      message: "admin.reported_users_list_reactivate_popup_message",
      yes_btn_text: "admin.reported_users_list_reactivate_popup_yes_btn_text",
      no_btn_text: "admin.reported_users_list_reactivate_popup_no_btn_text",
    },
    action_tooltip: {
      delete: "admin.reported_users_list_action_tooltip_delete",
      deactivate: "admin.reported_users_list_action_tooltip_deactivate",
      reactivate: "admin.reported_users_list_action_tooltip_reactivate",
    },
    messages: {
      delete_success: "admin.reported_users_list_messages_delete_success",
      delete_failed: "admin.reported_users_list_messages_delete_failed",
      deactivate_success: "admin.reported_users_list_messages_deactivate_success",
      deactivate_failed: "admin.reported_users_list_messages_deactivate_failed",
      reactivate_success: "admin.reported_users_list_messages_reactivate_success",
      reactivate_failed: "admin.reported_users_list_messages_reactivate_failed",
      fetch_failed: "admin.reported_users_list_messages_fetch_failed",
    },
    defaults: {
      na: "admin.reported_users_list_defaults_na",
    },
  },
};

export default reportedUsers;
